import { z } from 'zod';

const CITY_MAX_LENGTH = 256;

export const cityValidationMessages = {
  maximumLength: 'Maximum 256 characters',
  required: 'Required',
};

export const citySchema = z
  .string()
  .min(1, { error: cityValidationMessages.required })
  .max(CITY_MAX_LENGTH, { error: cityValidationMessages.maximumLength });
